const bookkeepingFeatures = [
  'Record income and expenses in seconds',
  'Track customer credit and payments owed',
  'Snap receipts and attach to entries',
  'Auto-generated profit & loss and cash flow reports',
]

const growthFeatures = [
  'Cloud backup — never lose records again',
  'Works on any phone, tablet, or computer',
  'Onboarding support through your accountant',
  'Unlock access to loans and financial services',
]

export function Features() {
  return (
    <section id="features" className="py-24 bg-white">
      <div className="mx-auto max-w-7xl section-padding">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-surface-900 mb-4">
            Everything you need to replace your paper ledger
          </h2>
          <p className="text-lg text-surface-600">
            Record transactions in seconds, track who owes you, and get real-time financial reports — all from your phone.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* Simple Bookkeeping */}
          <div className="card p-8">
            <div className="icon-box icon-box-cyan mb-6">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-surface-900 mb-2">Simple Bookkeeping</h3>
            <p className="text-surface-600 mb-6">
              No accounting knowledge needed. Just tap to record your daily sales, expenses, and customer credit — Ledger handles the rest.
            </p>
            <ul className="space-y-3">
              {bookkeepingFeatures.map((feature) => (
                <li key={feature} className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-accent-emerald flex-shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-surface-700">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Grow Your Business */}
          <div className="card p-8">
            <div className="icon-box icon-box-cyan mb-6">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-surface-900 mb-2">Grow Your Business</h3>
            <p className="text-surface-600 mb-6">
              What starts as simple bookkeeping becomes a trusted financial platform — helping you manage money, access funding, and grow.
            </p>
            <ul className="space-y-3">
              {growthFeatures.map((feature) => (
                <li key={feature} className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-accent-emerald flex-shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-surface-700">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
